
export { useFanTokenStakingAnalytics } from "/home/runner/work/capsicum/capsicum/libs/socios-core/shared/staking/hooks/useFanTokenStakingAnalytics.ts"